export function normalizeEncName(enc: string): string;
export function normalizeEncName(enc: string | undefined): string | undefined;
export function normalizeEncName(enc: string | undefined): string | undefined {
	return enc?.replace(/[\s_-]/g, '').toLowerCase();
}
